import { HttpErrorResponse } from '@angular/common/http';
import { Action, createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { GetAnnualReportTemplateTranslation } from '../dtos/get-annual-report-template-translation.dto';
import { UpdateAnnualReportTemplateTranslation } from '../dtos/update-annual-report-template-translation.dto';
import { IAnnualReportTemplateDTO } from '../interfaces/annual-report-template-dto.interface';
import { IARTemplateFilterCriteria } from '../interfaces/annual-report-template-filter-criteria.interface';
import { UpdateAnnualReportTemplateBalanceTaxonomyIdDto } from '../types/update-annual-report-template-balance-taxonomy-dto.type';
import { UpdateAnnualReportTemplateIncomeTaxonomyIdDto } from '../types/update-annual-report-template-income-taxonomy-dto';
import { UpdateAnnualReportTemplateNotesTemplateIdDto } from '../types/update-annual-report-template-notes-template-dto.type';
import { UpdateAnnualReportTemplatePdfTemplateIdDto } from '../types/update-annual-report-template-pdf-template-dto.type';
import { UpdateAnnualReportTemplateSettingsDto } from '../types/update-annual-report-template-settings-dto.type';

export const annualReportTemplateActions = createActionGroup({
    source: '[Aumico-Annual-Report-Template] annualReportTemplateActions',
    events: {
        'Create Ar Template': props<{
            payload: IAnnualReportTemplateDTO;
        }>(),
        'Create Ar Template Success': props<{ payload: IAnnualReportTemplateDTO }>(),
        'Create Ar Template Failed': props<{ payload: HttpErrorResponse }>(),

        'Update Ar Template': props<{
            payload: IAnnualReportTemplateDTO;
        }>(),
        'Update Ar Template Success': props<{ payload: IAnnualReportTemplateDTO }>(),
        'Update Ar Template Failed': props<{ payload: HttpErrorResponse }>(),

        'Get All Ar Templates': emptyProps(),
        'Get All Ar Templates Success': props<{ payload: IAnnualReportTemplateDTO[] }>(),
        'Get All Ar Templates Failed': props<{ payload: HttpErrorResponse }>(),

        'Get Ar Template By Id': props<{
            payload: string;
        }>(),
        'Get Ar Template By Id Success': props<{ payload: IAnnualReportTemplateDTO }>(),
        'Get Ar Template By Id Failed': props<{ payload: HttpErrorResponse }>(),

        'Delete Ar Template': props<{
            payload: string;
        }>(),
        'Delete Ar Template Success': props<{ payload: string }>(),
        'Delete Ar Template Failed': props<{ payload: HttpErrorResponse }>(),

        'Download Default Pdf Template': emptyProps(),
        'Download Default Pdf Template Success': props<{ payload: any }>(),
        'Download Default Pdf Template Failed': props<{ payload: HttpErrorResponse }>(),

        'Download Default Hgb Pdf Template': emptyProps(),
        'Download Default Hgb Pdf Template Success': props<{ payload: any }>(),
        'Download Default Hgb Pdf Template Failed': props<{ payload: HttpErrorResponse }>(),

        'Download Pdf Template': props<{ payload: string }>(),
        'Download Pdf Template Success': props<{ payload: any }>(),
        'Download Pdf Template Failed': props<{ payload: HttpErrorResponse }>(),

        'Upload Pdf Template': props<{ payload: any }>(),
        'Upload Pdf Template Success': props<{ payload: string }>(),
        'Upload Pdf Template Failed': props<{ payload: HttpErrorResponse }>(),

        'Set Ar Template Specifications': props<{ payload: IAnnualReportTemplateDTO }>(),

        'Set Ar Balance Sheet Taxonomy': props<{ payload: UpdateAnnualReportTemplateBalanceTaxonomyIdDto }>(),

        'Set Ar Income Statement Taxonomy': props<{ payload: UpdateAnnualReportTemplateIncomeTaxonomyIdDto }>(),

        'Set Ar Notes Template': props<{ payload: UpdateAnnualReportTemplateNotesTemplateIdDto }>(),

        'Set Pdf Information': props<{ payload: UpdateAnnualReportTemplatePdfTemplateIdDto }>(),

        'Set Ar Template Settings': props<{ payload: UpdateAnnualReportTemplateSettingsDto }>(),

        'Reset Selected Ar Template': emptyProps(),
        'Reset Taxonomies List': emptyProps(),

        'Get Ar Templates By Filter': props<{ payload: IARTemplateFilterCriteria }>(),
        'Get Ar Templates By Filter Success': props<{ payload: IAnnualReportTemplateDTO[] }>(),
        'Get Ar Templates By Filter Failed': props<{ payload: HttpErrorResponse }>(),

        'Get Ar Template Locales': props<{ payload: string }>(),
        'Get Ar Template Locales Success': props<{ payload: string[] }>(),
        'Get Ar Template Locales Failed': props<{ payload: HttpErrorResponse }>(),
    },
});

export const arTemplateTranslationsActions = {
    getTranslations: createAction(
        '[Aumico-Settings] arTemplateTranslationsActions.getTranslations',
        props<{ locales: string[]; untranslatedOnly: boolean }>(),
    ),
    onGetTranslationsSuccess: createAction(
        '[Aumico-Settings] arTemplateTranslationsActions.onGetTranslationsSuccess',
        props<{ payload: GetAnnualReportTemplateTranslation[] }>(),
    ),
    onGetTranslationsFailed: createAction(
        '[Aumico-Settings] arTemplateTranslationsActions.onGetTranslationsFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
    updateTranslations: createAction(
        '[Aumico-Settings] arTemplateTranslationsActions.updateTranslations',
        props<{ payload: UpdateAnnualReportTemplateTranslation[] }>(),
    ),
    onUpdateTranslationsSuccess: createAction(
        '[Aumico-Settings] arTemplateTranslationsActions.onUpdateTranslationsSuccess',
    ),
    onUpdateTranslationsFailed: createAction(
        '[Aumico-Settings] arTemplateTranslationsActions.onUpdateTranslationsFailed',
        props<{ payload: HttpErrorResponse }>(),
    ),
};

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
